import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import auth from '@/auth/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home, meta: { auth: true, breadCrumb: [{ text: 'Home'}] }
  },
  { path: '/bulk-imports', name: 'BulkImportsView', component: () => import('../views/BulkImportsView.vue'), meta: { auth: true, manageUsers: true, breadCrumb: [{ text: 'Cargas masivas'}] } },
  { path: '/bulk-imports/bank-accounts', name: 'BulkImportBankAccounts', component: () => import('../views/BulkImportBankAccountsView.vue'), meta: { auth: true, manageUsers: true, breadCrumb: [{ text: 'Carga masiva cuentas bancarias'}] } },
  { path: '/company/new', name: 'CompanyNew', component: () => import('../views/CompanyNew.vue'), meta: { auth: true, breadCrumb: [{ text: 'Nuevo Cliente'}] } },
  { path: '/company/:id', name: 'CompanyShow', component: () => import('../views/CompanyShow.vue'), meta: { auth: true, breadCrumb: [{ text: 'Cliente'}] } },
  { path: '/company/:company_id/record/new', name: 'RecordNew', component: () => import('../views/RecordNew.vue'), meta: { auth: true, breadCrumb: [{ text: 'Editar Cliente'}] } },
  { path: '/company/:company_id/record/edit', name: 'RecordEdit', component: () => import('../views/RecordEdit.vue'), meta: { auth: true, breadCrumb: [{ text: 'Editar Cliente'}] } },
  { path: '/billings', name: 'BillingsView', component: () => import('../views/BillingView.vue'), meta: { auth: true, breadCrumb: [{ text: 'Facturación'}] } },
  { path: '/billing/:id', name: 'BillingView', component: () => import('../views/Billing.vue'), meta: { auth: true, breadCrumb: [{ text: 'Facturación'}] } },
  { path: '/invoiceCompany/:id', name: 'invoiceCompany', component: () => import('../views/invoiceCompanyShow.vue'), meta: { auth: true, breadCrumb: [{ text: 'Datos proceso'}] } },
  { path: '/tracking', name: 'TrackingGeneralView', component: () => import('../views/TrackingGeneralView.vue'), meta: { auth: true, manageUsers: true, breadCrumb: [{ text: 'Seguimiento General'}] } },
  { path: '/users', name: 'UsersView', component: () => import('../views/UsersView.vue'), meta: { auth: true, manageUsers: true, breadCrumb: [{ text: 'Usuarios'}] } },
  { path: '/settings', name: 'SettingsView', component: () => import('../views/SettingsView.vue'), meta: { auth: true, breadCrumb: [{ text: 'Configuración'}] } },
  { path: '/settings/notifications', name: 'NotificationsView', component: () => import('../views/NotificationsView.vue'), meta: { auth: true, breadCrumb: [{ text: 'Notificaciones por correo'}] } },
  { path: '/settings/notifications', name: 'NotificationsView', component: () => import('../views/NotificationsView.vue'), meta: { auth: true, breadCrumb: [{ text: 'Notificaciones por correo'}] } },
  { path: '/login', name: 'LoginView', component: () => import('../views/LoginView.vue'), meta: { auth: false } },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { auth: true, breadCrumb: [{ text: 'Estado operativo'}] }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !auth.isLogged()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  if (to.meta.manageUsers && !auth.canManageUsers()) {
    next({ path: '/' })
    return
  }

  next()
})

export default router
